import { render, staticRenderFns } from "./change-full-name.vue?vue&type=template&id=248d9666&scoped=true&"
import script from "./change-full-name.vue?vue&type=script&lang=js&"
export * from "./change-full-name.vue?vue&type=script&lang=js&"
import style0 from "./change-full-name.vue?vue&type=style&index=0&id=248d9666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d9666",
  null
  
)

export default component.exports